import { render, staticRenderFns } from "./modalRejectSuccessfulMassive.vue?vue&type=template&id=215408a0&scoped=true&"
import script from "./modalRejectSuccessfulMassive.vue?vue&type=script&lang=js&"
export * from "./modalRejectSuccessfulMassive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215408a0",
  null
  
)

export default component.exports